module.exports = __webpack_public_path__ + "static/media/union-4.44101e6a.jpg";